<template>
  <div class="container">
    <div class="titleTopic">Overview</div>
    <div class="textParagraph">
      <p><strong>Welcome to FacilitaPay’s API Documentation</strong></p>
      <p>
        This guide covers everything you need to successfully integrate with FacilitaPay’s REST API and start using our
        payment technology. You’ll learn how to authenticate requests, register users, create transactions, initiate
        currency conversions, pay customers, receive international payments, and expand your operations across Latin
        America by understanding the region’s most widely used payment methods.
      </p>
      <p>
        This documentation applies to both our Sandbox environment (for testing) and Production environment (for live 
        operations). All requests and responses are formatted in <strong>JSON</strong>.
      </p>
      <p><strong>Sandbox environment:</strong></p>
      <v-layout align-center style="max-width: 600px;">
        <v-flex xs10>
          <div class="url-text">{{ sandboxUrl }}</div>
        </v-flex>
        <v-flex xs2>
          <v-btn icon small @click="copyToClipboard(sandboxUrl)">
            <v-icon>content_copy</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>

      <p><strong>Production environment:</strong></p>
      <v-layout align-center style="max-width: 600px;">
        <v-flex xs10>
          <div class="url-text">{{ productionUrl }}</div>
        </v-flex>
        <v-flex xs2>
          <v-btn icon small @click="copyToClipboard(productionUrl)">
            <v-icon>content_copy</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>



<script>
import Title from './../Title'

export default {
  name: 'Introduction',
  components: { Title },
  data() {
    return {
      sandboxUrl: 'https://sandbox-api.facilitapay.com/api/v1',
      productionUrl: 'https://api.facilitapay.com/api/v1'
    }
  },
  methods: {
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$emit('copied', text)
      }).catch(err => {
        console.error('Failed to copy text: ', err)
      })
    }
  }
}
</script>

<style scoped>
.titleTopic {
  font-family: 'Paralucent';
  font-size: 40px;
  padding: 1% 0px 0px;
}

.textParagraph  {
  font-family: 'Paralucent';
  font-size: 14px;
}

.url-text {
  margin: 2% 0px;
  display: flex;
  padding: 10px;
  justify-content: left;
  font-family: 'Courier New', Courier, monospace;
  font-weight: 500;
  font-size: 14px;
  background-color: #FAFAFA;
}
</style>



// WEBPACK FOOTER //
// src/components/documentation/Introduction.vue